<div class="container-fluid">
  <div class="k-flex-layout k-justify-content-between k-align-items-center">
    <h3>Agents Configuration</h3>
    <div>
      <button kendoButton [svgIcon]="hyperlinkIcon" themeColor="primary" (click)="openTab(chatbotUrl)">Test</button>
    </div>
  </div>

  <kendo-tabstrip style="width: 100%">
      <kendo-tabstrip-tab title="Chatbot" [selected]="true">
        <ng-template kendoTabContent>
          <app-agent-configuration [name]="'chatbot_agent'" [containsRagTool]="false"/>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="Rag Agent">
        <ng-template kendoTabContent>
          <app-agent-configuration [name]="'rag_agent'" [containsRagTool]="true"/>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="Search Agent">
        <ng-template kendoTabContent>
          <app-agent-configuration [name]="'search_agent'" [containsRagTool]="false"/>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="Quotation Agent">
        <ng-template kendoTabContent>
          <app-agent-configuration [name]="'quotation_agent'" [containsRagTool]="false"/>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="Statistics Agent" [disabled]="true">
        <ng-template kendoTabContent>
          <app-agent-configuration [name]="'statistics_agent'" [containsRagTool]="false"/>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>

    <div style="height: 50px"></div>
</div>
